import { render, staticRenderFns } from "./MerchantUpdateStatusModal.vue?vue&type=template&id=214ad414&scoped=true"
import script from "./MerchantUpdateStatusModal.vue?vue&type=script&lang=js"
export * from "./MerchantUpdateStatusModal.vue?vue&type=script&lang=js"
import style0 from "./MerchantUpdateStatusModal.vue?vue&type=style&index=0&id=214ad414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ad414",
  null
  
)

export default component.exports